import { NumberOutput } from 'services/device/domain/business/common/Output';
import { LabelRenderer } from 'services/device/presentation/ui/widget/label-renderer/LabelRenderer';
import { NumberOutputValueRenderer } from 'services/device/presentation/ui/widget/output-value-renderer/NumberOutputValueRenderer';

export interface NumberOutputProps {
	output: NumberOutput;
}

export const NumberOutputRenderer = (props: NumberOutputProps): JSX.Element => {
	const { output } = props;

	return (
		<li key={output.getName()}>
			<strong>
				<LabelRenderer output={output} />
			</strong>
			<p>
				<NumberOutputValueRenderer output={output} />
			</p>
		</li>
	);

};
